export default "__VITE_ASSET__C$0yR8J3__"